import { render, staticRenderFns } from "./BoxOS.vue?vue&type=template&id=4f1de1f6&scoped=true&"
import script from "./BoxOS.vue?vue&type=script&lang=js&"
export * from "./BoxOS.vue?vue&type=script&lang=js&"
import style0 from "./BoxOS.vue?vue&type=style&index=0&id=4f1de1f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1de1f6",
  null
  
)

export default component.exports